import React from 'react';
import cx from 'classnames';
import PageActions from 'components/page-actions/PageActions';
import TimerText from 'components/timer-text/TimerText';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useCheckPayment } from 'containers/selfe-booth/payment/useCheckPayment';
import { useAppContext } from 'context/AppContext';
import { useSoundContext } from 'context/SoundContext';
import { isEqualVal } from 'helpers/string.helper';
import { imageUrl } from 'helpers/url.helper';
import { useNewPhotoLifeCycleStep } from 'hooks/useNewPhotoLifeCycleStep';
import { usePageTimer } from 'hooks/usePageTimer';
import { useTranslation } from 'hooks/useTranslation';
import { compact, filter, find, findIndex, map, size } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { setSelfeAppStateAction } from 'store/features/app/selfeAppSlice';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import './printing-select-photo.css';

function PrintingSelectPhoto() {
  const { T } = useTranslation([I18nNamespace.COMMON, I18nNamespace.PAGE]);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { getPrevPath, getNextPath } = useNewPhotoLifeCycleStep();
  const { audio } = useSoundContext();
  const { isOnline } = useAppContext();
  const { second } = usePageTimer();
  const { isEnoughDeposit } = useCheckPayment();

  const { numberOfPrint, uploadedPhoto, selectedUploadedPhoto } =
    useAppSelector((state) => state.selfeApp);

  const { isVerticalScreen } = useAppSelector((s) => s.booth);

  // click Back
  const handleBack = () => {
    audio?.playBackClick?.();
    navigate(getPrevPath() || '');
  };

  // click Next
  const handleNext = () => {
    audio?.playContinueClick?.();
    navigate(getNextPath() || '');
  };

  const handleSelectPhoto = (fileName: string) => () =>
    dispatch(
      setSelfeAppStateAction({
        // eslint-disable-next-line no-nested-ternary
        selectedUploadedPhoto: find(selectedUploadedPhoto, (o) =>
          isEqualVal(o?.image, fileName),
        )
          ? filter(
              selectedUploadedPhoto,
              (o) => !isEqualVal(o?.image, fileName),
            )
          : size(selectedUploadedPhoto) >= numberOfPrint
          ? selectedUploadedPhoto
          : [...selectedUploadedPhoto, { image: fileName }],
      }),
    );

  const renderPaymentActions = () => (
    <PageActions
      NextButtonProps={{
        children: T('common:continue'),
        disabled:
          !isEnoughDeposit ||
          !isOnline ||
          !size(compact(selectedUploadedPhoto)),
      }}
      handleBack={handleBack}
      handleContinue={handleNext}
      className={cx({
        'printing-select-photo__page-actions--vertical': isVerticalScreen,
      })}
    />
  );

  return (
    <>
      <div className="printing-select-photo">
        <TimerText second={second} />
        {isVerticalScreen && renderPaymentActions()}
        {!isVerticalScreen && (
          <div className="page-title-wrapper printing-select-photo__page-title">
            <Typography
              variant={TYPOGRAPHY_VARIANTS.H1}
              data-text={T(`${I18nNamespace.COMMON}:uploadedPhoto`)}
              className="page-title"
            >
              {T(`${I18nNamespace.COMMON}:uploadedPhoto`)}
            </Typography>
          </div>
        )}
        <div className="printing-select-photo__wrapper">
          <div className={cx('printing-select-photo__payment-info-wrapper')}>
            <Typography variant={TYPOGRAPHY_VARIANTS.BODY}>
              Số lượng in: {size(uploadedPhoto)}
            </Typography>
            <Typography variant={TYPOGRAPHY_VARIANTS.BODY}>
              Thành tiền: 50.000đ
            </Typography>
          </div>
          <div className="printing-select-photo__photo-grid">
            {map(uploadedPhoto, (photo, index) => {
              const selectedPhotoIndex = findIndex(selectedUploadedPhoto, (o) =>
                isEqualVal(o?.image, photo),
              );
              const isSelectedPhoto = selectedPhotoIndex >= 0;

              return (
                <button
                  type="button"
                  className={cx('printing-select-photo__photo-item', {
                    active: selectedPhotoIndex >= 0,
                  })}
                  onClick={handleSelectPhoto(photo)}
                >
                  <img
                    src={imageUrl(photo)}
                    alt="uploaded-img"
                    className="no-drag"
                  />
                  <div className="printing-select-photo__actions">
                    {/* <button
                      type="button"
                      className="printing-select-photo__action-picture"
                    >
                      <AssetIcon.PictureOutline />
                    </button>
                    <button
                      type="button"
                      className="printing-select-photo__action-trash"
                    >
                      <AssetIcon.TrashOutline />
                    </button> */}
                    {isSelectedPhoto && (
                      <Typography
                        className="font-black printing-select-photo__order-text"
                        variant={TYPOGRAPHY_VARIANTS.XS}
                      >
                        {selectedPhotoIndex + 1}
                      </Typography>
                    )}
                  </div>
                </button>
              );
            })}
          </div>
        </div>
      </div>
      {!isVerticalScreen && renderPaymentActions()}
    </>
  );
}

export default PrintingSelectPhoto;
